import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/service/OrderFormService.js';
import 'app/service/BlockService.js';
import 'app/service/StatsdService.js';
import 'app/store/JobStore.js';
import 'app/store/MessageStore.js';

import 'app/action/ResetJobAction.js';
import 'app/action/ContentChangeAction.js';
import getStartedHtml from 'html/help/get-started.html';
import orderFormContainerHtml from 'html/home/order-form-container.html';

function HomeCtrl(
  RouterService,
  OrderFormService,
  MessageStore,
  SubjectStore,
  ContentStore,
  BlockService,
  JobStore,
  $routeParams,
  $location,
  $window,
  TranslateProviderService,
  ResetJobAction,
  ShoppingCartStore,
  $interval,
  $uibModal,
  $filter,
  $timeout,
  GradeService,
  $scope,
  ContentChangeAction,
  StatsdService,
  UserProfileStore,
  $rootScope,
  AnalyticsService,
  SessionTimeoutService,
  $templateCache
) {
  $templateCache.put('html/help/get-started.html', getStartedHtml);
  $templateCache.put('html/home/order-form-container.html', orderFormContainerHtml);

  this.HERO_IMG_DESKTOP_LOGGED_OUT = 'LANDING_HERO_IMG_DESKTOP_LOGGED_OUT';
  this.HERO_IMG_DESKTOP_LOGGED_IN = 'LANDING_HERO_IMG_DESKTOP_LOGGED_IN';
  this.HERO_IMG_MOBILE_LOGGED_IN = 'LANDING_HERO_IMG_MOBILE_LOGGED_IN';
  this.HERO_IMG_MOBILE_LOGGED_OUT = 'LANDING_HERO_IMG_MOBILE_LOGGED_OUT';
  this.CLAIM_HERO_IMG_DESKTOP_LOGGED_IN = 'LANDING_CLAIM_HERO_IMG_DESKTOP_LOGGED_IN';
  this.CLAIM_HERO_IMG_DESKTOP_LOGGED_OUT = 'LANDING_CLAIM_HERO_IMG_DESKTOP_LOGGED_OUT';
  this.CLAIM_HERO_IMG_MOBILE_LOGGED_IN = 'LANDING_CLAIM_HERO_IMG_MOBILE_LOGGED_IN';
  this.CLAIM_HERO_IMG_MOBILE_LOGGED_OUT = 'LANDING_CLAIM_HERO_IMG_MOBILE_LOGGED_OUT';

  this.portraitId = null;
  this.accessCode = null;
  this.firstName = null;
  this.lastName = null;
  this.grade = null;
  this.jobLoadFailed = false;
  this.cancelLabel = 'PICTURE_DAY_FORM_CANCEL';
  this.lockPortraitId = false;
  this.pageScope = 'HOME';
  this.pictureDayCopy = 'HOME_FORM_ENTER_PICTURE_DAY';
  this.isNeedHelpModalShown = false;
  this.isCanadianDomain = TranslateProviderService.isCanadianDomain();
  this.pidViaSmartLink = false;
  this.studentIdSelected = false;
  this.isMobileView = false;
  this.relationshipDisclaimer = false;
  this.isFindMyPictureDay = $scope.findMyPictureDay;
  this.imgAuthorization = null;
  this.showGlobalError = true;

  this.elementNames = OrderFormService.getElementsNamesMap();
  this.currentFlow = OrderFormService.getCurrentFlow();

  this.jobFailedConfig = {
    AUTHENTICATION_REQUIRED: {
      drawerTheme: 'login-required',
      iconName: 'user-lock',
      title: 'LOGIN_REQUIRED',
      subTitle: 'LOGIN_REQUIRED_SUBTEXT',
      buttonText: 'SIGN_IN_SIGN_UP',
      cancel: 'COMMON_TEXT_CANCEL'
    },
    LMI_CLAIM_NOT_ALLOWED: {
      drawerTheme: 'no-subject',
      iconName: 'triangle-warning',
      title: 'SUBJECT_UNAVAILABLE',
      subTitle: 'SUBJECT_UNAVAILABLE_SUBTEXT',
      buttonText: null,
      cancel: 'CLOSE'
    }
  };

  var cleanInput = function (value) {
    // clean up emojis - remove anything that is not Basic Latin or Latin-1 Supplement
    return !!value ? value.replace(/[^0-9\s\-'\u0041-\u007A\u00C0-\u00FF]/g, '').trim() : null;
  };

  this.showHideFindMyPictureDay = function () {
    this.isFindMyPictureDay = !this.isFindMyPictureDay;
    this.selectedAccount = SubjectStore.getSelectedAccount();
    if (this.selectedAccount) {
      this.studentIdSelected = this.selectedAccount.studentIdSelected;
    }
  };

  this.hasTeacherNameField = function () {
    var portraitIdForm = this.currentFlow.includes(this.elementNames.portraitIdForm);
    var pictureDayIdForm = this.currentFlow.includes(this.elementNames.pictureDayIdForm);
    return OrderFormService.getTeacherNameStatus() && (portraitIdForm || pictureDayIdForm);
  };
  this.init = function () {
    SessionTimeoutService.refresh();

    this.isMobileView = window.isMobile;

    this.orderStatusEnabled = window.orderStatusBannerEnabled.enabled;
    // the init function was not called at all previously, so only added back the parts I needed. 2016.08.02
    this.portraitId = cleanInput($routeParams.identifier);
    this.accessCode = cleanInput($routeParams.accessCode);
    this.firstName = cleanInput($routeParams.firstName);
    this.lastName = cleanInput($routeParams.lastName);
    this.email = !!$routeParams.email ? $routeParams.email.trim() : null;
    this.grade = GradeService.resolveGrade($routeParams.gradeCode);

    this.relationshipDisclaimer = $scope.relationshipDisclaimer;
    this.isLoggedIn = UserProfileStore.isLoggedIn();

    if (!!this.portraitId) {
      this.pidViaSmartLink = true;
      StatsdService.logSmartLink(RouterService.getSource());
    }

    if (this.isLoggedIn || !!this.email) {
      this.studentIdSelected = true;
    }
    if (SubjectStore.getSelectedAccount()) {
      this.selectedAccount = SubjectStore.getSelectedAccount();
      this.studentIdSelected = this.selectedAccount.studentIdSelected;
    }

    //Should always picture day id tab defaulted as request came through access credentials smart link
    if (this.pidViaSmartLink) {
      this.studentIdSelected = false;
    }

    if (!!this.portraitId && !!this.email) {
      this.pidViaSmartLink = false;
      this.studentIdSelected = false;
      StatsdService.logSmartLink(RouterService.getSource());
    }

    if ($rootScope.isComingFromPopup) {
      this.isFindMyPictureDay = true;
      BlockService.manuallyUnblockUI();
    }

    $scope.$watch(
      function () {
        return OrderFormService.currentFlow;
      },
      function () {
        this.currentFlow = OrderFormService.getCurrentFlow();
      }.bind(this)
    );

    const unwatchJobLoadFailedAction = $rootScope.$on('jobLoadFailed', () => {
      this.showGlobalError = true;
      this.jobLoadFailed = true;

      $scope.$broadcast('jobLoadFlagUpdated', true);

      const systemMessages = MessageStore.getSystemMessages();

      systemMessages.forEach((error) => {
        if (error.messageKey === 'AUTHENTICATION_REQUIRED' || error.messageKey === 'LMI_CLAIM_NOT_ALLOWED') {
          this.showGlobalError = false;
          this.loadJobFailedDialog(error.messageKey);
        }
      });

      if ($window.optimizeprepic && !this.isPortraitIdEntered()) {
        this.showGlobalError = false;
      }
    });

    $scope.$on('$destroy', function () {
      unwatchJobLoadFailedAction();
    });
  };

  this.backToSignIn = function () {
    OrderFormService.goToSignIn();
    $location.path('/');
    $location.search({});
    this.jobLoadFailed = false;
  };

  this.switchToFindMyPictureDay = function () {
    RouterService.goToFindSchool();
  };

  this.changeFlowToLifetouchCode = function () {
    OrderFormService.changeFlowToLifetouchCode();
  };

  this.changeFlowToStudentId = function () {
    OrderFormService.changeFlowToStudentId();
  };

  this.clearPictureDayForm = function () {
    //MessageStore.clear();
  };

  this.goToNext = function () {
    if (JobStore.isPreOrder()) {
      RouterService.goToPrepayStudentInfo();
    } else {
      var activeJob = JobStore.getJob();
      this.subject = ShoppingCartStore.getCurrentSubject();
      SubjectStore.addOrUpdateSubjectByJob(activeJob, this.subject);
      ShoppingCartStore.confirmSubjectAccount();
      RouterService.goToMyProofs();
    }
  };

  this.loadSpecDialog = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-choose-spec-order-drawer ' +
        'on-select-pay-only="modalCtrl.goToPayOnly()" ' +
        'on-select-order="modalCtrl.goToOrder()" ' +
        'cancel-choose-spec="modalCtrl.cancelChooseSpec()" ' +
        'cancellation-button-text="COMMON_TEXT_CANCEL"> ' +
        '</lt-choose-spec-order-drawer>',
      controller: function () {
        this.cancelChooseSpec = function () {
          modalInstance.close();
        };
        this.goToOrder = function () {
          modalInstance.close('goToOrder');
        };
        this.goToPayOnly = function () {
          modalInstance.close('goToPayOnly');
        };
      },
      controllerAs: 'modalCtrl'
    });

    modalInstance.result.then(
      function (action) {
        if (action === 'goToOrder') {
          this.goToOrder();
        } else if (action === 'goToPayOnly') {
          this.goToPayOnly();
        } else {
          // assume cancel
          modalInstance.close();
        }
      }.bind(this)
    );
  };

  this.goToPayOnly = function () {
    $timeout(function () {
      if (JobStore.isEnhancedPayOnly()) {
        RouterService.goToPrepayStudentInfo('ENHANCED_PAYONLY');
      } else {
        RouterService.goToPrepayStudentInfo('PAYONLY');
      }
    }, 10);
  };

  this.loadJobFailedDialog = function (key) {
    var that = this;
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-job-load-failed-drawer ' +
        'icon-name="{{modalCtrl.config.iconName}}"' +
        'drawer-theme="{{modalCtrl.config.drawerTheme}}"' +
        'drawer-title-key="{{modalCtrl.config.title}}"' +
        'drawer-desc-key="{{modalCtrl.config.subTitle}}"' +
        'cancel-key="{{modalCtrl.config.cancel}}" ' +
        'on-cancel="modalCtrl.cancelDrawer()"' +
        'on-emit="modalCtrl.emitAction()"' +
        'button-key="{{modalCtrl.config.buttonText}}">' +
        '</lt-job-load-failed-drawer>',
      controller: function () {
        this.config = that.jobFailedConfig[key];

        this.cancelDrawer = function () {
          modalInstance.close();
        };
        this.emitAction = function () {
          modalInstance.close('goToLogin');
        };
      },
      controllerAs: 'modalCtrl'
    });

    modalInstance.result.then(
      function (action) {
        if (action === 'goToLogin') {
          modalInstance.close();
          BlockService.manuallyUnblockUI();
          RouterService.goToLogin();
        } else {
          // assume cancel
          modalInstance.close();
        }
      }.bind(this)
    );
  };

  this.goToOrder = function () {
    var pdd = ShoppingCartStore.getPictureDayData();
    if (!pdd.accessCode || !JobStore.isJobLoaded()) {
      ShoppingCartStore.removeSubject(ShoppingCartStore.getCurrentSubject().id);
      MessageStore.createSystem('HOME_ACCESS_CODE_REQUIRED');
    } else {
      BlockService.blockUI();
      ShoppingCartStore.removeSubject(ShoppingCartStore.getCurrentSubject().id);
      pdd.specReorder = true;
      JobStore.loadJob(pdd, true)
        .then(function (data) {
          if (JobStore.isJobLoaded() && !!data && (data === true || (!!data.data && !!data.data.success))) {
            RouterService.goToHome();
          }
        })
        ['finally'](function () {
          BlockService.unblockUI();
        });
    }
  };

  this.getSystemMessages = function () {
    var errorMessage = MessageStore.getSystemMessages();
    var pictureDayLoadFailedMessage = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('JobHandler_job_error_not_found')
    );

    // Remove duplicates based on messageKey
    const uniqueErrorMessages = [...new Map(errorMessage.map((item) => [item.messageKey, item])).values()];
    if (uniqueErrorMessages.length > 0 && uniqueErrorMessages[0].message === pictureDayLoadFailedMessage) {
      return;
    }

    return uniqueErrorMessages;
  };

  this.removeErrorByIndex = function (index) {
    MessageStore.removeErrorByIndex(index);
  };

  this.getExplainerUrl = function () {
    RouterService.goToExplainer();
  };

  this.getYBPayUrl = function () {
    if (TranslateProviderService.isCanadianDomain()) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_YBPAY_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'YBPAY_URL');
  };

  this.getYBImageSrc = function () {
    return ContentStore.getContentImageUrl('RIGHT_CONTENT_HOME', ContentStore.appendCountryCode('RIGHT_IMAGE_SRC'));
  };

  this.getLeftImageSrc = function () {
    return ContentStore.getContentImageUrl('LEFT_CONTENT_HOME', ContentStore.appendCountryCode('LEFT_IMAGE_SRC'));
  };

  this.getSportsUrl = function () {
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', ContentStore.appendCountryCode('SPORTS_ORDERING_URL'));
  };

  this.goToExplainer = function () {
    RouterService.goToExplainer();
  };

  this.goToCreateAccount = function () {
    RouterService.goToCreateAccount();
  };

  this.getContentByZone = function (zoneName, key) {
    key = ContentStore.appendCountryCode(key);
    return ContentStore.getContent(zoneName, key);
  };

  this.backToTop = function () {
    $window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  this.showHeroImageMessage = () => {
    const titleKey = ContentStore.appendCountryCode('LANDING_HERO_TITLE_DESKTOP');
    const subtitleKey = ContentStore.appendCountryCode('LANDING_HERO_SUBTITLE_DESKTOP');

    const title = $filter('ltTranslateFilter')(titleKey);
    const subtitle = $filter('ltTranslateFilter')(subtitleKey);

    return title?.trim() && subtitle?.trim();
  };

  this.getHeroImageStyle = function (isMobile) {
    var code;
    code =
      'LANDING_CLAIM_HERO_IMG' + (isMobile ? '_MOBILE' : '_DESKTOP') + (this.isLoggedIn ? '_LOGGED_IN' : '_LOGGED_OUT');

    var content = ContentStore.getContent(null, ContentStore.appendCountryCode(code));
    var url = ContentStore.resolveContentImagePath(content);

    // Override content url with CDN url if available
    if (window.cdnImages && content) {
      var cdnImages = window.cdnImages;
      Object.keys(cdnImages).forEach(function (img) {
        if (content.includes(img)) {
          url = cdnImages[img];
        }
      });
    }

    return {
      'background-image': 'url("' + url + '")'
    };
  };

  this.isPortraitIdEntered = function () {
    return OrderFormService.getCurrentFlow().includes('portraitIdForm');
  };

  $scope.$on('$destroy', function () {
    if ($location.path() !== '/') {
      $rootScope.isComingFromPopup = false;
    }
    BlockService.unblockUI();
  });
}

App.controller('HomeCtrl', [
  'RouterService',
  'OrderFormService',
  'MessageStore',
  'SubjectStore',
  'ContentStore',
  'BlockService',
  'JobStore',
  '$routeParams',
  '$location',
  '$window',
  'TranslateProviderService',
  'ResetJobAction',
  'ShoppingCartStore',
  '$interval',
  '$uibModal',
  '$filter',
  '$timeout',
  'GradeService',
  '$scope',
  'ContentChangeAction',
  'StatsdService',
  'UserProfileStore',
  '$rootScope',
  'AnalyticsService',
  'SessionTimeoutService',
  '$templateCache',
  HomeCtrl
]);
